<script>
import MapContainer from "@/components/mapContainer.vue";
import _ from "lodash";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MapContainer,
  },
  data() {
    return {
      mapContainer: null,
      show_map: false,
    };
  },
  methods: {
    handleOpen() {
      this.show_map = true;
    },
    closeDialog() {
      this.$emit("close");
    },
    handleConfirm() {
      if (!this.$refs.mapContainer.current_address_json) {
        this.$message.warning("请选择地址");
        return;
      }
      let obj = _.cloneDeep(this.$refs.mapContainer.current_address_json);
      obj.lng = obj.location.split(",")[0];
      obj.lat = obj.location.split(",")[1];
      this.$emit("confirm", obj);
    },
  },
};
</script>

<template>
  <el-dialog
    title="位置选择"
    :visible.sync="show"
    width="50%"
    @opened="handleOpen"
    :close-on-click-modal="false"
    top="8vh"
  >
    <MapContainer ref="mapContainer"></MapContainer>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleConfirm"> 确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped lang="less"></style>
